export const rules = {
  OLD_DEALS_ONLY: "old_deals_of_parent_stage_only",
  NEW_DEALS_ONLY: "new_deals_of_parent_stage_only",
  MOVEFROMREQUIRETICKET: "move-from-require-ticket",
  MOVETOREQUIRETICKET: "move-to-require-ticket",
  MOVEFROMREQUIRECOMMENT: "move-from-require-comment",
  MOVETOREQUIRECOMMENT: "move-to-require-comment",
  MOVETOREMOVEASSIGNEDTOID: "move-to-remove-assigned-to-id",
  MOVEFROMREMOVEASSIGNEDTOID: "move-from-remove-assigned-to-id",
  MOVETOSTAGEAFTERTIMER: "move-to-stage-after-timer",
  MOVETOSTAGEWHENRESPOND: "move-to-stage-when-respond",
  MOVETOREQUIREPRETRASHTAG: "move-to-require-pre-trash-tag",
  MOVETOREQUIREESSENTIALDEALINFO: "move-to-require-essential-deal-info",
  MOVETOREMOVECOMMENTPINS: "move-to-remove-comment-pins",
  MOVETOCOMPLETETASKS: "move-to-complete-tasks",
  MOVETOREMOVEHIGHLIGHT: "move-to-remove-highlight",
  MOVETORESETDEAL: "move-to-reset-deal",
  MOVEFROMREQUIRECOOLDOWNMINUTESAFTERDEALLASTMOVEDDATE:
    "move-from-require-cooldown-minutes-after-deal-last-moved-date",
  MOVETOREQUIRECONFIRMATION: "move-to-require-confirmation",
  LOCKDEALS: "lock-deals",
  BEPULLED: "be-pulled",
  NOTBEDISPLAYEDINTASKSKANBAN: "not-be-displayed-in-tasks-kanban",
  TASKWITHOUTDUEDATE: "tasks-without-duedate",
  DEALSWITHNOTASKS: "deals-with-no-tasks",
  TASKSWITHDUEDATEEQUALSTODAYPLUS: "tasks-with-duedate-equals-today-plus",
  TASKSWITHDUEDATEEQUALSTODAYMINUS: "tasks-with-duedate-equals-today-minus",
  TASKSWITHDUEDATEGREATERTHANTODAYMINUSSTART:
    "tasks-with-duedate-greater-than-today-minus-start",
  TASKSWITHDUEDATEGREATERTHANTODAYMINUSEND:
    "tasks-with-duedate-greater-than-today-minus-end",
  TASKSWITHDUEDATEGREATERTHANTODAYPLUSSTART:
    "tasks-with-duedate-greater-than-today-plus-start",
  TASKSWITHDUEDATEGREATERTHANTODAYPLUSEND:
    "tasks-with-duedate-greater-than-today-plus-end",
  TASKSWITHDUEDATEGREATERTHANTHISWEEKPLUSSTART:
    "tasks-with-duedate-greater-than-this-week-plus-start",
  TASKSWITHDUEDATEGREATERTHANTHISWEEKPLUSEND:
    "tasks-with-duedate-greater-than-this-week-plus-end",
  TASKSWITHDUEDATEGREATERTHANTHISWEEKMINUSSTART:
    "tasks-with-duedate-greater-than-this-week-minus-start",
  TASKSWITHDUEDATEGREATERTHANTHISWEEKMINUSEND:
    "tasks-with-duedate-greater-than-this-week-minus-end",
  TASKSWITHDUEDATELESSTHANTODAYMINUSSTART:
    "tasks-with-duedate-less-than-today-minus-start",
  TASKSWITHDUEDATELESSTHANTODAYMINUSEND:
    "tasks-with-duedate-less-than-today-minus-end",
  TASKSWITHDUEDATELESSTHANTODAYPLUSSTART:
    "tasks-with-duedate-less-than-today-plus-start",
  TASKSWITHDUEDATELESSTHANTODAYPLUSEND:
    "tasks-with-duedate-less-than-today-plus-end",
  TASKSWITHDUEDATELESSTHANTHISWEEKPLUSSTART:
    "tasks-with-duedate-less-than-this-week-plus-start",
  TASKSWITHDUEDATELESSTHANTHISWEEKPLUSEND:
    "tasks-with-duedate-less-than-this-week-plus-end",
  TASKSWITHDUEDATELESSTHANTHISWEEKMINUSSTART:
    "tasks-with-duedate-less-than-this-week-minus-start",
  TASKSWITHDUEDATELESSTHANTHISWEEKMINUSEND:
    "tasks-with-duedate-less-than-this-week-minus-end",
};
